import { ref } from 'vue'
import GuestDestinationService from '@/services/GuestDestinationService'

export function useGuestDestinations(stream) {
	const guestDestinations = ref([])
	const guestDestinationsSet = ref(new Set())
	const hasGuestDestinationSetInit = ref(false)

	async function fetchGuestDestinations(destinations = null) {
		if (destinations) {
			guestDestinations.value = destinations
		} else {
			guestDestinations.value = await GuestDestinationService.getDestinations(stream.value._id)
		}
		const next = new Set()
		guestDestinations.value.forEach((x) => {
			x.destinations.forEach((dest) => {
				next.add(`${dest.server}-${dest.key}`)
			})
		})
		guestDestinationsSet.value = next
		hasGuestDestinationSetInit.value = true
	}

	function isGuestDestinationRemoved(platform) {
		if (!hasGuestDestinationSetInit.value) return false
		if (platform.key && platform.server) {
			return !guestDestinationsSet.value.has(`${platform.server}-${platform.key}`)
		}
		return false
	}

	function clearGuestSet() {
		guestDestinationsSet.value = new Set()
	}

	return {
		guestDestinations,
		guestDestinationsSet,
		hasGuestDestinationSetInit,
		fetchGuestDestinations,
		isGuestDestinationRemoved,
		clearGuestSet,
	}
}
